import React, { useState, useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';
import adminLogo from '../../Images/admin_img.jpg';
import AppModal from '../../shared/AppModal';
import './trainingLibrary.css';

const TRAINING_AUDIOS = [
  { title: 'Divorce Life Event - Edward Haar (Wayne 2)',                link: 'https://assets.cdn.filesafe.space/lmdPZBnct1qETepFwbdi/media/6a68e5268219a56ed32695d1.mp3' },
  { title: 'Hung up - Edward Haar (Blessings Robbins)',                 link: 'https://assets.cdn.filesafe.space/lmdPZBnct1qETepFwbdi/media/6a68e6cfa0ca605ff3b770d2.mp3' },
  { title: "I'm busy at work - Edward Haar (Dinesh)",                  link: 'https://assets.cdn.filesafe.space/lmdPZBnct1qETepFwbdi/media/6a68e6cfa0ca605ff3b77047.mp3' },
  { title: 'No not interested - John Colatosti (Bhag Singh)',          link: 'https://assets.cdn.filesafe.space/lmdPZBnct1qETepFwbdi/media/6a68e6cfa0ca605ff3b77036.mp3' },
  { title: 'Supposed Wrong Number - Edward Haar (Taina & Mr Robinson)', link: 'https://assets.cdn.filesafe.space/lmdPZBnct1qETepFwbdi/media/6a68e6cf18a264df539f68bf.mp3' },
  { title: 'Taking an app - Edward Haar (Ganaa)',                      link: 'https://assets.cdn.filesafe.space/lmdPZBnct1qETepFwbdi/media/6a68e6cf609da4cf5806b052.mp3' },
];

const TRAINING_VIDEOS = [
  { id: 'v1', title: 'How to disposition your leads - John Colatosti / Bcrumbs CRM', link: 'https://assets.cdn.filesafe.space/lmdPZBnct1qETepFwbdi/media/6a68e6ee8219a56ed3281740.mp4' },
];

// Module-level so SCRIPT_SECTIONS can reference them
const cn = <span className="var">Maria</span>;
const src = <span className="var">Facebook</span>;
const page = <span className="var">Long Island Homes for Sale</span>;

const SCRIPT_SECTIONS = [
  {
    id: 'greeting',
    title: 'Greeting',
    searchText: 'greeting hey pre-approved mortgage facebook lead reach out buy house',
    content: (
      <>
        <div className="rep">Hey {cn}?</div>
        <div className="rep">Hey {cn}! It's <span className="var">Your Name</span>, you reached out to us on {src}, on {page}, you're looking to buy a house?</div>
        <div className="cust">Yes</div>
        <div className="rep">Ok great! I can definitely help. Have you been pre-approved for a mortgage yet?</div>
        <h4>If they say no (more common)</h4>
        <div className="cust">No</div>
        <div className="rep">Okay great, not a problem we can help you with that today. What do you do for work?</div>
        <p className="note">Proceed with the application.</p>
        <h4>If they say yes</h4>
        <div className="cust">Yes</div>
        <div className="rep">Okay great, you are 2 steps ahead! Have you been out to see any houses in person yet? How much are you approved for, what is your price range? What type of home are you looking for?</div>
      </>
    ),
  },
  {
    id: 'taking-app',
    title: 'Taking an application',
    searchText: 'taking application work income savings credit home search completing date of birth social paystubs retirement 401k gift down payment cosign renting kids',
    content: (
      <>
        <p className="note">Conversational cadence. Move naturally from one area to the next.</p>
        <h4>Work</h4>
        <div className="rep">What do you do for work? Awesome, how long have you been doing that?</div>
        <div className="rep">Okay awesome. How much do you make a year? And do you have any other sources of income?</div>
        <p className="note">Gather a full 2 to 3 years of work history: "Okay and what did you do before that?"</p>
        <h4>Savings</h4>
        <div className="rep">Okay awesome. How much do you have saved so far?</div>
        <div className="rep">Okay great. And do you have any sort of retirement account, like a 401k or anything?</div>
        <div className="rep">Okay great. Do you have any friends or family that would be giving you a gift to help with your down payment or closing costs?</div>
        <h4>Credit</h4>
        <div className="rep">Okay awesome. And how is your credit? Rough estimate, what do you think your credit score is?</div>
        <h4>Current home</h4>
        <div className="rep">Ok great. Where do you live now? Are you renting?</div>
        <div className="rep">Ok excellent. How long have you been living there? How much is your rent?</div>
        <div className="rep">Is anyone else going to be buying the house with you or cosigning? Is there anyone else who is working in your household?</div>
        <h4>Home search</h4>
        <div className="rep">Ok great. Now the fun part, what kind of house do you think you would want? What type of home are you looking for?</div>
        <div className="rep">Are there any particular areas you are interested in?</div>
        <div className="rep">Do you have any kids? Who would be living in the house with you?</div>
        <h4>Completing the app</h4>
        <div className="rep">Okay awesome. What's your date of birth?</div>
        <div className="rep">Great, and what's your social?</div>
      </>
    ),
  },
  {
    id: 'requesting-docs',
    title: 'Requesting the documents',
    searchText: 'requesting documents employee salary wage earner business owner self employed tax returns W2 1099 paystubs bank statements ID SS card lunch break appointment email fax accountant',
    content: (
      <>
        <p className="section-body">Request the supporting documents while you are still on the call.</p>
        <div className="rep">Okay great! Now we just need to collect a few documents, and then we will review your full application, your credit, your documents, and me and the senior loan officer will give you a call back to go over everything!</div>
        <h4>Employee, salary, or wage earner document list</h4>
        <div className="doc">Last 2 years of tax returns</div>
        <div className="rep">Who usually does your taxes for you? How do they usually send them, in an email or a physical copy? If it's easier you can put me in touch with your tax person, we work with accountants all the time.</div>
        <p className="note">If they have their taxes accessible:</p>
        <div className="rep">Okay great, send it over. I'm going to send you an email right now with the list of documents we need, you can respond to that email.</div>
        <p className="note">If they don't file taxes:</p>
        <div className="rep">Oh okay, not a problem, we have programs for that also for business owners or self employed. We can go strictly off your bank statements.</div>
        <p className="note">If they hesitate about documents:</p>
        <div className="rep">Oh pardon my manners, let me send you all my information (send digital business card) so you can put a face to the name. That is the address to our office and the name of our company (send location card). If it's more comfortable you're welcome to come to our office, but usually it's more convenient to send everything over email or fax.</div>
        <div className="doc">Last 2 years of W2s or 1099s</div>
        <div className="rep">This is usually in your HR portal where you clock in.</div>
        <div className="doc">1 month of paystubs</div>
        <div className="rep">How do you get paid, checks or direct deposit? You can usually download it from your HR portal.</div>
        <div className="doc">Last 2 months of bank statements</div>
        <div className="rep">You can usually export from your bank app on your phone.</div>
        <div className="doc">Clear picture of your ID and SS card</div>
        <div className="rep">You are probably sitting on your ID right now.</div>
        <div className="script-space" />
        <div className="rep">If you have 2 minutes we can grab everything together now and me and the loan officer can call you back later today with good news!</div>
        <p className="note">If they say no:</p>
        <div className="rep">Are you sure? It will only take 2 minutes.</div>
        <p className="note">If they say no:</p>
        <div className="rep">Okay, do you take a lunch break during the day usually?</div>
        <p className="note">If they say no:</p>
        <div className="rep">Okay no worries, what time do you get home?</div>
        <p className="note">If they say no:</p>
        <div className="rep">Haha okay, I understand life is busy. When will you have 5 minutes to work on this? I will make myself available so I can confirm everything is perfect.</div>
        <div className="rep">Okay great, I will mark this in our calendar, I'll reach out to remind you of the appointment. Did you have any questions for me?</div>
        <h4>Business owner or self employed document list</h4>
        <div className="doc">Last 2 years of tax returns</div>
        <div className="rep">Same approach as above. If it's easier, connect us with their tax preparer.</div>
        <div className="doc">Last 2 months of bank statements</div>
        <div className="rep">You can export from your bank app. You can also provide 12 to 24 months of bank statements if you typically write off all your income on taxes or do not file taxes, and we can use that to qualify. Sometimes that is easier for business owners.</div>
        <div className="doc">Clear picture of your ID and SS card</div>
      </>
    ),
  },
  {
    id: 'qualified',
    title: 'If the application seems qualified',
    searchText: 'qualified houses weekend saturday sunday showing in person purchase biggest',
    content: (
      <>
        <div className="rep">Okay great, now more importantly, what do you have going on this weekend? When do you think you would have time to go see some houses in person, is Saturday or Sunday better? Okay great, what time?</div>
        <p className="note">If they say no:</p>
        <div className="rep">Oh of course! Remember this is the biggest purchase of your life, so it's not about rushing. A lot of people don't realize going to see houses in person is completely free. It's really just taking advantage and seeing what's available in your price range, what the payments would be. Seeing houses in person is WAY different than the pictures online. And it's usually fun, it helps you imagine your future and see the neighborhoods!</div>
      </>
    ),
  },
  {
    id: 'follow-up',
    title: 'Following up for documents',
    searchText: 'following up documents busy lunch break evening calendar appointment tax preparer',
    content: (
      <>
        <div className="rep">Hi {cn}, glad I caught you! I know life is busy, you probably didn't get a chance to look at the email. Are you going to be available to go see houses this week or this weekend? If you have 2 minutes now I can probably grab everything we need. Do you have 2 minutes now?</div>
        <div className="rep">Are you sure? It will only take 2 minutes.</div>
        <div className="rep">Ah okay no problem, when do you usually have a lunch break?</div>
        <p className="note">If they say no:</p>
        <div className="rep">Okay, will you have time this evening when you get home?</div>
        <p className="note">If they say no:</p>
        <div className="rep">Okay no problem, you tell me when is best, it will really only take 2 or 3 minutes. Also, more importantly, when do you think you'll be available to go see houses? Before I let you go, who prepares your taxes? If it's easier for you they'll probably have everything we need.</div>
        <p className="note" style={{ marginTop: '24px', textAlign: 'center' }}>End of script</p>
      </>
    ),
  },
];

function fmt(sec) {
  const m = Math.floor(sec / 60), s = Math.floor(sec % 60);
  return `${m}:${s.toString().padStart(2, '0')}`;
}

function AudioCard({ audio, idx, isPlaying, onToggle }) {
  const audioRef = useRef(null);
  const [progress, setProgress] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);

  useEffect(() => {
    if (!isPlaying && audioRef.current) {
      audioRef.current.pause();
    }
  }, [isPlaying]);

  const handleToggle = () => {
    if (!audioRef.current) return;
    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
    onToggle(idx);
  };

  const handleTimeUpdate = () => {
    const a = audioRef.current;
    if (!a) return;
    setCurrentTime(a.currentTime);
    setProgress(a.duration ? (a.currentTime / a.duration) * 100 : 0);
  };

  const handleLoadedMetadata = () => {
    if (audioRef.current) setDuration(audioRef.current.duration || 0);
  };

  const handleEnded = () => onToggle(null);

  const handleSeek = (e) => {
    if (!audioRef.current || !audioRef.current.duration) return;
    const rect = e.currentTarget.getBoundingClientRect();
    const ratio = (e.clientX - rect.left) / rect.width;
    audioRef.current.currentTime = ratio * audioRef.current.duration;
  };

  return (
    <div className="tl-audio-card">
      <audio
        ref={audioRef}
        src={audio.link}
        onTimeUpdate={handleTimeUpdate}
        onLoadedMetadata={handleLoadedMetadata}
        onEnded={handleEnded}
        preload="metadata"
      />
      <div className="tl-audio-title">{audio.title}</div>
      <div className="tl-audio-controls">
        <button className={`tl-play-btn${isPlaying ? ' playing' : ''}`} onClick={handleToggle}>
          {isPlaying
            ? <i className="pi pi-pause" style={{ fontSize: 14 }} />
            : <i className="pi pi-play" style={{ fontSize: 14 }} />
          }
        </button>
        <div className="tl-progress-wrap">
          <div className="tl-progress-bar" onClick={handleSeek}>
            <div className="tl-progress-fill" style={{ width: `${progress}%` }} />
          </div>
          <div className="tl-time">{fmt(currentTime)} / {fmt(duration)}</div>
        </div>
      </div>
    </div>
  );
}

const TABS = [
  { key: 'script', label: 'Call Script',     icon: 'pi-file-edit' },
  { key: 'audio',  label: 'Training Calls',  icon: 'pi-headphones' },
  { key: 'video',  label: 'Training Videos', icon: 'pi-video' },
];

function VideoCard({ video, onClick }) {
  return (
    <div
      onClick={onClick}
      style={{
        background: 'rgba(255,255,255,0.07)',
        border: '1px solid rgba(255,255,255,0.12)',
        borderRadius: 16,
        overflow: 'hidden',
        cursor: 'pointer',
        transition: 'transform 0.18s, box-shadow 0.18s',
      }}
      onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-3px)'; e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.4)'; }}
      onMouseLeave={e => { e.currentTarget.style.transform = ''; e.currentTarget.style.boxShadow = ''; }}
    >
      <div style={{ width: '100%', aspectRatio: '16/9', background: '#111', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ width: 60, height: 60, borderRadius: '50%', background: 'rgba(255,255,255,0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <i className="pi pi-play" style={{ color: '#fff', fontSize: 22, marginLeft: 3 }} />
        </div>
      </div>
      <div style={{ padding: '1rem 1.1rem', color: '#fff', fontWeight: 600, fontSize: 14, lineHeight: 1.4 }}>
        {video.title}
      </div>
    </div>
  );
}

function TrainingLibrary() {
  const isSuperuser = useSelector((state) => state.user.isSuperuser);
  const image = useSelector((state) => state.user.image);
  const [activeTab, setActiveTab] = useState('script');
  const [playingIdx, setPlayingIdx] = useState(null);
  const [videoOpen, setVideoOpen] = useState(false);
  const [activeVideo, setActiveVideo] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');

  const handleAudioToggle = (idx) => {
    setPlayingIdx(prev => (prev === idx ? null : idx));
  };

  const openVideo = (video) => {
    setActiveVideo(video);
    setVideoOpen(true);
  };

  const q = searchQuery.trim().toLowerCase();
  const isSearching = q.length > 0;

  const matchedScriptSections = isSearching
    ? SCRIPT_SECTIONS.filter(s =>
        s.title.toLowerCase().includes(q) || s.searchText.toLowerCase().includes(q)
      )
    : [];

  const matchedAudios = isSearching
    ? TRAINING_AUDIOS.map((a, i) => ({ ...a, originalIdx: i })).filter(a =>
        a.title.toLowerCase().includes(q)
      )
    : [];

  const matchedVideos = isSearching
    ? TRAINING_VIDEOS.filter(v => v.title.toLowerCase().includes(q))
    : [];

  const hasResults = matchedScriptSections.length > 0 || matchedAudios.length > 0 || matchedVideos.length > 0;

  return (
    <>
      <div
        className="kanbanContainer"
        style={{
          backgroundImage: `url("${isSuperuser ? adminLogo : image}")`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          minHeight: '100vh',
          position: 'relative',
        }}
      >
        <div
          className="table-inner-div"
          style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 0 }}
        />

        <div style={{ position: 'relative', zIndex: 1, padding: '2rem' }}>
          {/* Header */}
          <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: '1.5rem', flexWrap: 'wrap', gap: '1rem' }}>
            <div>
              <h2 style={{ color: '#fff', fontWeight: 700, fontSize: 24, margin: 0 }}>Training Library</h2>
              <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: 14, marginTop: 4, marginBottom: 0 }}>
                Call scripts, training calls and video walkthroughs
              </p>
            </div>
            {/* Search */}
            <div style={{ position: 'relative', minWidth: 260 }}>
              <i className="pi pi-search" style={{
                position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)',
                color: 'rgba(255,255,255,0.4)', fontSize: 14, pointerEvents: 'none',
              }} />
              <input
                type="text"
                placeholder="Search scripts, audio, videos…"
                value={searchQuery}
                onChange={e => setSearchQuery(e.target.value)}
                style={{
                  paddingLeft: 36, paddingRight: searchQuery ? 32 : 14,
                  paddingTop: 9, paddingBottom: 9,
                  borderRadius: 10,
                  border: '1px solid rgba(255,255,255,0.18)',
                  background: 'rgba(255,255,255,0.09)',
                  color: '#fff',
                  fontSize: 14,
                  outline: 'none',
                  width: '100%',
                  boxSizing: 'border-box',
                }}
              />
              {searchQuery && (
                <button
                  onClick={() => setSearchQuery('')}
                  style={{
                    position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)',
                    background: 'none', border: 'none', color: 'rgba(255,255,255,0.4)',
                    cursor: 'pointer', fontSize: 13, padding: '2px 4px', lineHeight: 1,
                  }}
                >✕</button>
              )}
            </div>
          </div>

          {/* Tabs — hidden while searching */}
          {!isSearching && (
            <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '2rem', flexWrap: 'wrap' }}>
              {TABS.map(tab => (
                <button
                  key={tab.key}
                  onClick={() => setActiveTab(tab.key)}
                  style={{
                    padding: '0.55rem 1.3rem',
                    borderRadius: 8,
                    border: '1px solid rgba(255,255,255,0.2)',
                    cursor: 'pointer',
                    fontWeight: 600,
                    fontSize: 14,
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.4rem',
                    background: activeTab === tab.key ? '#fff' : 'rgba(255,255,255,0.07)',
                    color: activeTab === tab.key ? '#000' : 'rgba(255,255,255,0.75)',
                    transition: 'all 0.2s',
                    outline: 'none',
                  }}
                >
                  <i className={`pi ${tab.icon}`} style={{ fontSize: 13 }} />
                  {tab.label}
                </button>
              ))}
            </div>
          )}

          {/* Search results */}
          {isSearching && (
            <div>
              {!hasResults && (
                <div style={{ color: 'rgba(255,255,255,0.5)', fontSize: 15, padding: '2rem 0' }}>
                  No results found for <strong style={{ color: '#fff' }}>"{searchQuery}"</strong>
                </div>
              )}

              {matchedAudios.length > 0 && (
                <div style={{ marginBottom: '2rem' }}>
                  <div className="tl-search-category">
                    <i className="pi pi-headphones" style={{ fontSize: 13 }} /> Training Calls
                  </div>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))', gap: '1rem' }}>
                    {matchedAudios.map(audio => (
                      <AudioCard
                        key={audio.originalIdx}
                        audio={audio}
                        idx={audio.originalIdx}
                        isPlaying={playingIdx === audio.originalIdx}
                        onToggle={handleAudioToggle}
                      />
                    ))}
                  </div>
                </div>
              )}

              {matchedVideos.length > 0 && (
                <div style={{ marginBottom: '2rem' }}>
                  <div className="tl-search-category">
                    <i className="pi pi-video" style={{ fontSize: 13 }} /> Training Videos
                  </div>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '1rem', maxWidth: 680 }}>
                    {matchedVideos.map(video => (
                      <VideoCard key={video.id} video={video} onClick={() => openVideo(video)} />
                    ))}
                  </div>
                </div>
              )}

              {matchedScriptSections.length > 0 && (
                <div style={{ marginBottom: '2rem' }}>
                  <div className="tl-search-category">
                    <i className="pi pi-file-edit" style={{ fontSize: 13 }} /> Call Script
                  </div>
                  {matchedScriptSections.map(section => (
                    <div key={section.id} style={{ background: '#fff', borderRadius: 12, marginBottom: 16, overflow: 'hidden', boxShadow: '0 4px 16px rgba(0,0,0,0.25)' }}>
                      <div style={{
                        background: '#f7f8f9', padding: '0.75rem 1.25rem',
                        borderBottom: '1px solid #e9e4db',
                        fontWeight: 700, fontSize: 15, color: '#000',
                      }}>
                        {section.title}
                      </div>
                      <div className="tl-script-body">
                        {section.content}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

          {/* Normal tab content */}
          {!isSearching && activeTab === 'script' && (
            <div style={{ maxWidth: 1200 }}>
              <div style={{ background: '#fff', borderRadius: 16, overflow: 'hidden', boxShadow: '0 4px 24px rgba(0,0,0,0.3)' }}>
                <div style={{
                  background: '#f7f8f9',
                  padding: '1rem 1.5rem',
                  borderBottom: '1px solid #e9e4db',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}>
                  <span style={{ fontWeight: 700, fontSize: 16, color: '#000' }}>Sales Call Script</span>
                  <span style={{ fontSize: 12, color: '#8a8a8a', background: '#eef0f2', padding: '3px 10px', borderRadius: 20 }}>Breadcrumbs CRM</span>
                </div>
                <div className="tl-script-body">
                  {SCRIPT_SECTIONS.map((section, i) => (
                    <React.Fragment key={section.id}>
                      {i > 0 && <div className="script-space" />}
                      <h3>{section.title}</h3>
                      {section.content}
                    </React.Fragment>
                  ))}
                </div>
              </div>
            </div>
          )}

          {!isSearching && activeTab === 'audio' && (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))', gap: '1rem' }}>
              {TRAINING_AUDIOS.map((audio, idx) => (
                <AudioCard
                  key={idx}
                  audio={audio}
                  idx={idx}
                  isPlaying={playingIdx === idx}
                  onToggle={handleAudioToggle}
                />
              ))}
            </div>
          )}

          {!isSearching && activeTab === 'video' && (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '1rem', maxWidth: 680 }}>
              {TRAINING_VIDEOS.map((video) => (
                <VideoCard key={video.id} video={video} onClick={() => openVideo(video)} />
              ))}
            </div>
          )}
        </div>
      </div>

      <AppModal
        visible={videoOpen}
        onHide={() => { setVideoOpen(false); setActiveVideo(null); }}
        panelStyle={{ width: 920, maxWidth: '95vw' }}
        footer={null}
      >
        {activeVideo && (
          <video
            src={activeVideo.link}
            controls
            autoPlay
            style={{ width: '100%', borderRadius: 8, display: 'block' }}
          />
        )}
      </AppModal>
    </>
  );
}

export default TrainingLibrary;
